module.exports = __webpack_public_path__ + "static/media/solar-pannel.68d10662.png";